// extracted by mini-css-extract-plugin
export default {"wrapper":"productdetail_wrapper__sm6Lm","top":"productdetail_top__nWm8o","row":"productdetail_row__V4yk-","signatureWrapper":"productdetail_signatureWrapper__Ns-BQ"};